import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { isString } from 'lodash';

// ✅ FUNCIÓN ESPECÍFICA PARA ERRORES DE ARCHIVO DEMASIADO GRANDE
const toastFileSizeError = (err) => {
	const errorMsg = err.response?.data?.error;
	const errorCode = err.response?.data?.code;
	
	// ✅ VERIFICAR SI ES ERROR DE ARCHIVO DEMASIADO GRANDE
	if (errorCode === 'FILE_TOO_LARGE' && errorMsg) {
		toast.error(errorMsg, {
			toastId: 'file-too-large-error',
			autoClose: false, // ✅ NO CERRAR AUTOMÁTICAMENTE
			hideProgressBar: true, // ✅ OCULTAR BARRA DE PROGRESO
			closeOnClick: false, // ✅ NO CERRAR AL HACER CLIC
			pauseOnHover: true, // ✅ PAUSAR AL HOVER
			draggable: true,
			progress: undefined,
			theme: "light",
			style: {
				backgroundColor: '#ff4444',
				color: '#ffffff',
				fontSize: '14px',
				fontWeight: 'bold',
				maxWidth: '400px',
				whiteSpace: 'pre-line' // ✅ PERMITIR SALTOS DE LÍNEA
			}
		});
		return true; // ✅ INDICAR QUE SE MANEJÓ EL ERROR
	}
	
	return false; // ✅ INDICAR QUE NO SE MANEJÓ
};

const showErrorToast = (message, baseId) => {
	const toastId = `${baseId || "error"}-${Date.now()}`;
	toast.error(message, {
		toastId,
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
		theme: "light",
	});
};

const toastError = err => {
	// ✅ MANEJAR ERRORES DE ARCHIVO DEMASIADO GRANDE PRIMERO
	if (toastFileSizeError(err)) {
		return;
	}

	const data = err.response?.data;
	const errorMsg = data?.error;
	const code = data?.code || errorMsg;

	if (code === "ERR_COMPANY_EXPIRED") {
		return;
	}

	if (code && i18n.exists(`backendErrors.${code}`)) {
		const interpolation = {};
		if (data?.queueName != null) {
			interpolation.queueName = data.queueName;
		}
		if (data?.whatsappId != null) {
			interpolation.whatsappId = String(data.whatsappId);
		}
		const hasInterp = Object.keys(interpolation).length > 0;
		showErrorToast(
			hasInterp ? i18n.t(`backendErrors.${code}`, interpolation) : i18n.t(`backendErrors.${code}`),
			code
		);
		return;
	}
	if (errorMsg) {
		showErrorToast(errorMsg, String(errorMsg).slice(0, 40));
		return
	} if (isString(err)) {
		showErrorToast(err, "string-error");
		return
	} else {
		showErrorToast(
			i18n.exists("backendErrors.ERR_UNKNOWN") ? i18n.t("backendErrors.ERR_UNKNOWN") : "An error occurred!",
			"unknown"
		);
		return
	}
};

export default toastError;
